const isPlatformSubdomain = (subdomain: string) => (
  subdomain === "platform"
  || subdomain === "eu-platform"
  || subdomain === "platform-staging"
  || subdomain === "localhost:4000"
  || subdomain === "localhost"
);

export default isPlatformSubdomain;
